// src/store/modules/platformStore.js
import { defineStore } from 'pinia';
import { DEFAULT_TAB_LIST } from '@/config/tabConfig';

// 定义平台全局状态仓库
export const usePlatformStore = defineStore('platform', {
  // 全局平台状态数据
  state: () => ({
    // 当前选中平台的 UI key（如 jdd/tmm，对应 TabbarSwitch）
    currentUiKey: 'tmm',
    // 当前选中平台的 data key（如 jd/taobao，对应 搜索/接口请求，核心同步字段）
    currentDataKey: 'tm',
    // 平台列表（从配置导入，保持全局一致）
    platformList: DEFAULT_TAB_LIST || []
  }),

  // 派生状态（可选，简化模板使用，快速获取当前平台信息）
  getters: {
    // 当前选中平台的完整信息
    currentPlatform: (state) => {
      return state.platformList.find(p => p.dataKey === state.currentDataKey) || state.platformList[0];
    },
    // 当前平台名称（如 东啊东/猫啊猫）
    currentPlatformName: (state) => {
      return state.currentPlatform?.name || '东啊东';
    }
  },

  // 同步方法（修改平台状态的唯一入口，确保状态一致性）
  actions: {
    /**
     * 更新全局平台状态（核心方法，用于所有平台切换场景）
     * @param {Object} platform - 平台对象（包含 dataKey / uiKey）
     */
    updatePlatform(platform) {
      if (!platform || !platform.dataKey || !platform.key) return;
      this.currentDataKey = platform.dataKey;
      this.currentUiKey = platform.key;
    },

    /**
     * 初始化平台状态（可选，页面加载时兜底）
     */
    initPlatform() {
      const defaultPlatform = this.platformList[0] || { dataKey: 'jd', key: 'jdd' };
      this.currentDataKey = defaultPlatform.dataKey;
      this.currentUiKey = defaultPlatform.key;
    }
  }
});
